import { isValidLatLng } from 'src/app/modules/shared/helpers/location.helper';
import { ObjectNames } from 'src/app/shared/constants';
import { PermissionService } from './../../service/permission.service';
import { PhoneNumberFormatService } from './../../modules/shared/services/phone-number-format.service';
import { COMPANY_DEFAULT_LOGO } from './../../modules/shared/constants/company-default-logo';
import { TitleCasePipe } from "@angular/common";
import { ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import * as moment from "moment";
import { ConfirmationService, MessageService } from "primeng/api";
import { AccountService } from "src/app/accounts/accountService";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { AddEditAddressModalService } from "src/app/modules/shared/components/address/address-add-update-modal/address-add-update-modal.service";
import { ConfigurationService } from "../configurationService";
import { CompanyBranchService } from "./company-branch.service";
import { addInList } from "src/app/modules/shared/helpers";
import * as _ from "lodash";
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { Table } from 'primeng/table';
import { AccountUserService } from 'src/app/service/account.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EditCompanyDetails, ImageDetails } from '../models/organization-settings.model';
import { SetupService } from '../inventory/setup/setup.service';
import { Severity } from 'src/app/inventory/constants/constants';
import { firstValueFrom } from 'rxjs';
declare var google;

@Component({
    selector: "app-company-branch",
    templateUrl: "./company-branch.component.html",
    styleUrls: ["./company-branch.component.scss"],
})
export class CompanyBranchComponent implements OnInit, OnDestroy {
    constructor(
        public _ngZone: NgZone,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        public app: AppMainComponent,
        private service: ConfigurationService,
        private companyService: CompanyBranchService,
        private accountService: AccountService,
        private appMainService: AppMainService,
        private addEditAddressModalService: AddEditAddressModalService,
        private titlecasePipe: TitleCasePipe,
        private accountUserService: AccountUserService,
        private phoneNumberFormatService: PhoneNumberFormatService,
        private importService: ImportserialService,
        private permissionService: PermissionService,
        private fb: FormBuilder, private setupService: SetupService,private cd: ChangeDetectorRef
    ) {
        window["cpntRef"] = { component: this, zone: this._ngZone };
        this.companyInitForm(null);
    }
    company: any = [];
    selectedCountry: any;
    countryData: any;
    maskingDisabled: boolean = false;
    phoneNumberFormat: string = null;
    options: any;
    overlays: any[];
    public fileData: any;
    public icon: any;
    countries: any[] = [];
    allStates: any[] = [];
    allCities: any[] = [];
    locationTypes: any[] = [];
    allTypes: any[] = [];
    showAccountInfoMore: boolean = false;
    employees: any[] = [];
    revenues: any[] = [];
    ownerships: any[] = [];
    categories: any[] = [];
    industries: any[] = [];
    allCurrencies = [];
    tableShowMore: number[] = [15, 30, 50, 100];
    allCountryCurrencies = [];
    availableCurrencyList = [];
    displayCurrencyAdd = false;
    currencySymbol;
    addressInput = ""
    countryCodes = [
        { id: 1, name: "USD - United States Dollar", code: "USD" },
        { id: 2, name: "INR - Indian Rupee", code: "INR" },
        { id: 3, name: "CNY - Yuan Renminbi", code: "CNY" },
    ];
    decimals = [];
    today = new Date();
    allSettings = [];
    displaySetting2 = false;
    DefaultTimeoutData: any;
    formattedaddress = "";
    latitude = 0;
    longitude = 0;
    selectedAddressCountry = null;
    selectedAddressState = null;
    selectedAddressCity = null;
    stateList = [];
    cityList = [];
    latitudeFromGM: number;
    longitudeFromGM: number;
    latLongForMap: any[] = [];
    latLongForMapOptions: any[] = [];
    showAddressValidationError: boolean = false;
    selectedBranches: any[] = [];
    selectAll: boolean = false;
    // selectedCurrency = {
    //     currencyId: 126,
    //     name: "Afghanis",
    //     code: "AFN",
    //     description: "Afghanistan",
    //     symbol: "Ø‹        ",
    //     countryId: 1,
    //     country: {
    //         name: "Afghanistan",
    //         shortName: "Afghanistan",
    //         countryCode: "AF",
    //         phoneCode: 93,
    //         description: null,
    //         statusId: 1,
    //         status: null,
    //         id: 1,
    //         createdSource: "192.168.1.1",
    //         updatedSource: "192.168.1.1",
    //         createdBy: 1,
    //         updatedBy: 1,
    //         createdDate: "2021-01-15T16:57:03.477",
    //         updatedDate: "2021-01-15T16:57:03.477",
    //     },
    //     label: "Test 00011",
    // };
    currency;
    selectedCurrency;
    exchangeRate :any
    exchangeRatedate = this.app._showDateTimeWithZone(new Date());
    currencyForm: FormGroup; 
    currencyFormArray: FormArray; 
    displayMode;

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();

    //access control
    accessControl = "all";
    accessControlData: any[] = [];
    moduleDataAccess: boolean = true;
    selectedAccessControl: any;
    organizationFullDetails: any = null;
    timeZoneList: any[] = [];
    selectedTimeZone: any;
    isEnable: boolean = true;
    @ViewChild('dt2') dt2: Table;
    @ViewChild('searchInput') searchInput: ElementRef; // This is the reference to the input field

    //two factor authentication
    allTwoFactorData: any;
    twoFactor: any[] = [];
    selectedFactor: any[] = [];
    companyForm: FormGroup;

    roleMenuPermission: boolean = false;

    companyMap: any = null;
    companyMapMarkers: any[] = [];
    mapInfoWindow: any;

    ngOnInit(): void {
        // this.getCountryData();
        // this.getPhoneNumberTemplate();
        this.initMap();
        this.getCompanyAndBranches();
        this.getCurrencyForm();
        const userPermissions = this.permissionService.getPemrissionData();
        const roleUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ROLE);
        this.roleMenuPermission = roleUerPermission ? (roleUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
    }

    async initMap(){
        const { Map } = await google.maps.importLibrary("maps");

        let lat = this.latLongForMapOptions?.[0]?.latitude||0;
        let lng = this.latLongForMapOptions?.[0]?.longitude||0;

        var mapOptions = {
            zoom: 10,
            center: new google.maps.LatLng(lat, lng),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            disableDefaultUI: false,
            draggable: true,
            scrollwheel: true,
            disableDoubleClickZoom: false,
            panControl: true,
            streetViewControl: true,
            overviewMapControl: true,
            mapTypeControl: true,
            scaleControl: true,
            rotateControl: true,
            fullscreenControl: true,
            mapId: "656915a1a1b695a4"
        };

        const mapId = document.getElementById('map');

        if(mapId){
            this.companyMap = new Map(document.getElementById('map'), mapOptions);
            this.setCompanyMarkers();
        }
    }

    getCurrencyForm(){
        this.currencyForm = this.fb.group({
            id:[0],
            selectedCurrency: [null, [Validators.required]],
            exchangeRate: [null, [Validators.required, Validators.min(0.000001)]],
            defaultRateEnabled: [false],
            enableRecalculateItemRate: [false]
          });
    }
    
    closeInfoWindow(){
        this.mapInfoWindow?.close();
    }

    clearAllMarkers(){
        if(this.companyMapMarkers?.length>0){
            this.companyMapMarkers.map(mapMarker=>{
                mapMarker.setMap(null);
            });
            this.companyMapMarkers = [];
        }
    }

    setCompanyMarkers(){
        this.mapInfoWindow = new google.maps.InfoWindow();
        let bounds = new google.maps.LatLngBounds();
        let markerCount = 0;
        const map = this.companyMap;
        this.clearAllMarkers();

        this.latLongForMap.map(markerLatLng=>{
            if(isValidLatLng(markerLatLng.lat,markerLatLng.lng)){
                markerCount++;
                bounds.extend(markerLatLng);
                const advancedMarkerView = new google.maps.marker.AdvancedMarkerElement({
                    map,
                    content: this.buildContent(),
                    position: markerLatLng,
                    title: markerLatLng.title
                });

                advancedMarkerView.addListener('click', () => {
                    const content = `<div class="map-marker-details-wrapper">
                                        <div class="marker-details-header">
                                            <h5>${markerLatLng.title}</h5>
                                            <span class="close-icon pi pi-times" onclick="window.cpntRef.zone.run(() => {window.cpntRef.component.closeInfoWindow();})"></span>
                                        </div>
                                    </div>`;
                    this.mapInfoWindow.close();
                    this.mapInfoWindow.setContent(content);
                    this.mapInfoWindow.open(advancedMarkerView.map, advancedMarkerView);
                });

                this.companyMapMarkers.push(advancedMarkerView);
            }
        })
    }

    buildContent() {
        const content = document.createElement("div");

        content.classList.add("map-marker");
        content.innerHTML = `
            <div class="marker-wrapper">
                <div class="icon">
                    <div class="marker-pin" style="--marker-color: #fac61b"></div>
                </div>
            </div>
          `;
        return content;
    }

    async loadcompanyData(): Promise<void> {
        this.appMainService.isShowSpinner('loadcompanyData');
    
        const groupPromise = this.service.getQustionnaireGroupId().then(async (res) => {
            let selectedGroup = res.find((e) => e.name == "Location Type");
            if (selectedGroup) {
                this.locationTypes = await this.service.getallQuestionnaireGroups(selectedGroup.id);
            }
        });
        const [
            employees,
            revenues,
            ownerships,
            categories,
            industries,
            countries,
        ] = await Promise.all([
            await this.accountService.getAllEmployeesCount(),
            await this.accountService.getAllRevenues(),
            await this.accountService.getAllOwnerships(),
            await this.accountService.getAccountStages(),
            await this.accountService.getAllIndustries(),
            firstValueFrom(this.service.getAllCountries()),
            groupPromise,
        ]) as [any[], any[], any[], any[], any[], any[], unknown];
    
        this.employees = employees;
        this.revenues = revenues;
        this.ownerships = ownerships;
        this.categories = JSON.parse(JSON.stringify(categories));
        this.industries = industries;
        this.countries = countries;
    
        this.appMainService.isHideSpinner('loadcompanyData');
    }  

    getallQuestionnaireGroups(group) {
        if (group) {
            this.service.getallQuestionnaireGroups(group.id).then((res) => {
                this.locationTypes = res;
            });
        }
    }
    getAccessControl(): void {
        this.appMainService.isShowSpinner('getAccessControl');
        this.companyService.getAccessControl()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.accessControlData = response;
                    this.selectedAccessControl = this.accessControlData.find((x) => x.isSelected == true);
                    this.appMainService.isHideSpinner('getAccessControl');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('getAccessControl');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'AcccessControl is not loaded..' });
                }),
                complete: (() => {
                })
            });

    }

    saveAccessControl(): void {
        const accessControlData = {
            id: this.selectedAccessControl?.id,
            isReportHierarchyBased: this.selectedAccessControl?.id==2 ? (this.selectedAccessControl?.isReportHierarchyBased||false) : true
        }

        this.confirmationService.confirm({
            message: "Do you want to change users access control?",
            header: "Change Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.appMainService.isShowSpinner('saveAccessControl');
                this.companyService.saveAccessControl(accessControlData)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe({
                        next: (response) => {
                            this.getAccessControl();
                            this.appMainService.isHideSpinner('saveAccessControl');
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Access Control Updated Successfully' });
                        },
                        error: ((error) => {
                            this.appMainService.isHideSpinner('saveAccessControl');
                            this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'AcccessControl is not Updated..' });
                        }),
                        complete: (() => {
                        })
                    });
            },
            reject: () => { },
        });


    }

    getAllStates(countryObj) {
        this.service.getAllStates(countryObj.id).then((states) => {
            this.allStates = states;
        });
    }

    getAllCities(stateObj) {
        this.service.getAllCities(stateObj.id).then((cities) => {
            this.allCities = cities;
        });
    }

    getCompanyAndBranches() {
        this.service.getAllTypes().then((types) => {
            this.allTypes = types;
            let headOfficeTypeId = this.allTypes.filter(
                (e) => e.name == "Head Office"
            )[0].id;
            let branchOfficeTypeId = this.allTypes.filter(
                (e) => e.name == "Sub Branch"
            )[0].id;

            this.service
                .getOrganizationData()
                .subscribe((org) => {
                    this.organizationFullDetails = org;
                    this.app.appLogo = org?.image?.location;

                    let thisCompany = {
                        id: org.id,
                        name: org.name,
                        founder: org.founderName,
                        estDate: new Date(org.establishDate),
                        imageId: org.imageId,
                        image: org.image
                            ? org.image.location
                            : COMPANY_DEFAULT_LOGO,
                        active: org.statusId == 1 ? true : false,
                        web: org.website,
                        twitter: org.twitterIdentification,
                        facebook: org.facebookIdentification,
                        branches: [],
                    };

                    this.latLongForMapOptions = [];
                    let newBranches = [];
                    let latLong = [];
                    let emptyString = "";
                    this.service
                        .getOrganizationBranchesAddress(
                        )
                        .subscribe((branches) => {
                            for (let b of branches) {

                                if (b.organizationAddressPhone.length > 1) {
                                    b.organizationAddressPhone = b.organizationAddressPhone.sort((a, b) => a.id - b.id);
                                }

                                if (b.organizationAddressEmail.length > 1) {
                                    b.organizationAddressEmail = b.organizationAddressEmail.sort((a, b) => a.id - b.id);
                                }

                                const phoneDetails = b.organizationAddressPhone && b.organizationAddressPhone.length
                                    ? b.organizationAddressPhone[0]
                                    : null;

                                const emailDetails = b.organizationAddressEmail && b.organizationAddressEmail.length
                                    ? b.organizationAddressEmail[0]
                                    : null;

                                let branch = {
                                    id: b.id,
                                    locationId: b?.locationId,
                                    name:
                                        b.name == ""
                                            ? "null name"
                                            : b.name,
                                    phone: phoneDetails ? phoneDetails.phone.number : "not available",
                                    phoneMainId: phoneDetails ? phoneDetails.id : 0,
                                    editPhoneId: phoneDetails ? phoneDetails.phoneId : 0,
                                    emailId: emailDetails ? emailDetails.email.emailAddress : "not available",
                                    emailMainId: emailDetails ? emailDetails.id : 0,
                                    editEmailId: emailDetails ? emailDetails.emailId : 0,
                                    streetAddress2: b.address.streetAddress2 ?? "",
                                    addressId: b.addressId,
                                    address:
                                        b.address?.streetAddress1 +
                                        (b.address.streetAddress2
                                            ? " " + b.address.streetAddress2
                                            : ""),
                                    city:
                                        b.address.city == null
                                            ? "empty city"
                                            : b.address.city.name,
                                    cityId: b.address.cityId,
                                    cityObj: null,
                                    stateId: b.address?.stateId,
                                    state: b.address?.state?.name,
                                    stateObj: null,
                                    countryId: b.address?.countryId,
                                    country: b.address?.country?.name,
                                    countryObj: null,
                                    zip: b.address.zipCode,
                                    locationTypeId: b.locationTypeId,
                                    locationType: b.locationType
                                        ? b.locationType?.name
                                        : 0,
                                    headOffice:
                                        b.typeId == headOfficeTypeId
                                            ? true
                                            : false,
                                    latitude: b.address?.latitude,
                                    longitude: b.address?.longitude,
                                };
                                newBranches.push(branch);
                                latLong.push({
                                    lat: branch.latitude,
                                    lng: branch.longitude,
                                    title: branch.state
                                });
                                this.latLongForMapOptions.push(branch);
                            }

                            newBranches = newBranches.sort((a, b) => b.headOffice - a.headOffice);
                            thisCompany.branches = newBranches;
                            this.company = [thisCompany];
                            this.latLongForMap = latLong;
                            this.initMap();
                        });
                });
        });
    }

    getAllCurrencies() {
        this.companyService.getAllCurrencies().subscribe((res) => {
            this.allCurrencies = res;
            this.importService.setOrgCurrency(this.allCurrencies);
            this.loadCurrencies();
        });
    }

    getAllCountryCurrencies() {
        this.companyService.getAllCountryCurrencies().subscribe((res) => {
            this.allCountryCurrencies = res;
            if (this.allCountryCurrencies && this.allCountryCurrencies.length) {
                this.allCountryCurrencies.forEach((element) => {
                    if (element.code && element.country?.name) {
                        element["label"] =
                            element.code + " - " + element.country.name;
                    }
                });
            }
        });
    }

    loadCurrencies() {
        this.currencyFormArray?.clear();
        this.allCurrencies.forEach((currency) => {
            this.currencyFormArray.push(
                this.fb.group({
                    exchangeRate: new FormControl(currency.exchangeRate, [Validators.required, Validators.min(0.000001)]),
                }),
            );
        });
    }

    saveCurrency(type) {
        if (!this.selectedCurrency?.countryId) {
            this.currencyForm.get('selectedCurrency')?.setErrors({ empty: true });
            this.selectedCurrency = null;
          } else {
            this.currencyForm.get('selectedCurrency')?.setErrors(null);
            this.selectedCurrency = this.currencyForm.get('selectedCurrency')?.value;
          }
        const formData = this.currencyForm.getRawValue();
        const data = this.prepareCurrencyData(formData, type);
        const functionName = type == "EDIT" ? "updateCurrency" : "saveCurrency";
        this.companyService[functionName](data).subscribe({
            next: (res) => {
                this.displayCurrencyAdd = false;
                this.getAllCurrencies();
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: `${type == "EDIT" ? 'Updated' : 'Saved'}`  + ' Successfully...',
                });
            },
            error: (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error Occured",
                });
            },
        });
    }
    
    prepareCurrencyData(formData,type){
        const data = {
            id: type == 'EDIT' ? formData?.id : 0,
            updatedSource: this.app.userIP,
            updatedBy: this.app.user.userId,
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
            createdSource: type == 'EDIT' ? this.currency?.createdSource : this.app.userIP,
            createdBy: type == 'EDIT' ? this.currency?.createdBy.createdBy : this.app.user.userId,
            createdDate: type == 'EDIT' ? this.currency?.createdDate :this.app._saveDateTimeWithZone(new Date()),
            organizationId: this.app.companyId,
            name: this.selectedCurrency?.name ?? "",
            currencyId: this.selectedCurrency?.currencyId ?? 0,
            symbol: this.selectedCurrency?.symbol ?? "",
            code: this.selectedCurrency?.code ?? "",
            countryId: this.selectedCurrency?.countryId ?? 0,
            isBaseCurrency: type == 'EDIT' ? this.currency.isBaseCurrency : false,
            exchangeRate: formData.exchangeRate ?? this.currency.exchangeRate ?? 0,
            statusId: type == 'EDIT' ? this.currency.statusId : 1,
            defaultRateEnabled: formData.defaultRateEnabled ?? false,
            enableRecalculateItemRate: formData.enableRecalculateItemRate ?? false,
            exchangeRateUpdatedDate: (type == 'EDIT' && this.exchangeRate == formData.exchangeRate) ? this.currency.exchangeRateUpdatedDate : this.app._saveDateTimeWithZone(new Date()),
            exchangeRateUpdatedBy:(type == 'EDIT' && this.exchangeRate == formData.exchangeRate) ? this.currency.exchangeRateUpdatedBy :  this.app.user.userId,
        };
        return data
    }

    updateBaseCurrency(currency,index) {
        const updatedRate = this.currencyFormArray?.at(index)?.get('exchangeRate')?.value;
        if (updatedRate <= 0) {
            this.messageService.add({ severity: 'warn', summary: 'Warn', detail: 'Exchange Rate must be greater than 0....' });
            return;
        }
        const obj = {
            ..._.cloneDeep(currency),
            exchangeRate: updatedRate,
            updatedBy: this.app.user.userId,
            updatedSource: this.app.userIP,
            updatedDate: this.app._saveDateTimeWithZone(new Date()),
        };
        this.companyService.updateCurrency(obj).subscribe({
            next: (res) => {
                this.getAllCurrencies();
                this.messageService.add({
                    severity: "success",
                    summary: this.titlecasePipe.transform("success"),
                    detail: "Updated Successfully...",
                });
            },
            error: (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: "Error Occured",
                });
            },
          });
    }
  checkDeleteStatus(currency) {
    this.companyService.validateCurrencyPermissions(currency?.currencyId).subscribe(resp => {
        if(resp){
          this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: "This currency is already in use, so we cannot delete it." });
        }else{
            this.deleteCurrency(currency) 
        }
      });
  }
    deleteCurrency(currency) {
        this.confirmationService.confirm({
            message: "Do you want to delete this Currency?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.companyService.deleteCurrency(currency.id).subscribe({
                    next: (res) => {
                        this.getAllCurrencies();
                        this.messageService.add({
                            severity: "success",
                            summary: this.titlecasePipe.transform("success"),
                            detail: "Deleted Successfully...",
                        });
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: "error",
                            summary: this.titlecasePipe.transform("error"),
                            detail: "Error Occured",
                        });
                    }
                });
            },
            reject: () => { },
        });
    }

    getUniqueObjects(array1, array2, key) {
        return array1.filter(obj1 => 
            !array2.some(obj2 => obj1[key] === obj2[key])
        );
    }

    showAddCurrency() {
        this.getCurrencyForm();
        this.currencyForm.get('selectedCurrency').enable();
        this.availableCurrencyList = this.getUniqueObjects(this.allCountryCurrencies,this.allCurrencies,'currencyId');
        this.displayCurrencyAdd = true;
        this.displayMode = "ADD";
        this.selectedCurrency = null;
    }

    patchCurrencyForm(selectedCurrency) {
        this.currencyForm.patchValue({
            id : selectedCurrency?.id,
            selectedCurrency: selectedCurrency,
            exchangeRate: selectedCurrency.exchangeRate,
            defaultRateEnabled: selectedCurrency.defaultRateEnabled,
            enableRecalculateItemRate: selectedCurrency.enableRecalculateItemRate
        });
    }
    
    showEditCurrency(currency) {
        this.displayMode = "EDIT";
        this.selectedCurrency = null
        this.currencyForm.get('selectedCurrency').disable();
        this.availableCurrencyList = this.allCountryCurrencies;
        this.currency = _.cloneDeep(currency);
        if (this.currency) {
            this.patchCurrencyForm(this.currency)
         }
        this.exchangeRate = this.currency.exchangeRate;
        this.selectedCurrency = this.allCountryCurrencies?.find(c => c.currencyId === currency.currencyId);
        if (this.selectedCurrency) {
            this.displayCurrencyAdd = true;
        }
    }

    onCurrencySelect(): void {
        const selectedCurrency = this.currencyForm.get('selectedCurrency')?.value;
        const isDuplicate = this.allCurrencies.some(
          (currency) => currency.currencyId === selectedCurrency?.currencyId
        );
        if (isDuplicate) {
            this.currencyForm.get('selectedCurrency')?.setErrors({ duplicate: true });
            this.selectedCurrency = null;
          } else {
            this.currencyForm.get('selectedCurrency')?.setErrors(null);
            this.selectedCurrency = this.currencyForm.get('selectedCurrency')?.value;
          }
      }

    getOptions() {
        this.options = {
            center: {
                lat: this.latLongForMapOptions[0].latitude,
                lng: this.latLongForMapOptions[0].longitude,
            },
            zoom: 3,
        };
    }

    changeTabView(e) {
        let index = e.index;
        switch (index) {
            case 1:
                this.initMap();
                break;
            case 2:
                this.currencyFormArray = this.fb.array([]);
                this.getAllCurrencies();
                this.getAllCountryCurrencies();
                break;
            case 3:
                this.getConfigurtationFortimeout();
                this.getOrgSettings();
                break;
            case 4:
                this.getAccessControl();
                break;
            case 5:
                this.getAllMFAUserList();
                break;
        }
    }

    displayCompany = false;
    public tempCompany = <any>{};

    editCompany(company) {
        this.getTimeZoneList();
        this.tempCompany.id = company.id;
        this.tempCompany.name = company.name;
        this.tempCompany.founder = company.founder;
        this.tempCompany.estDate = company.estDate;
        this.tempCompany.imageId = company.imageId;
        this.tempCompany.image = company.image;
        this.tempCompany.active = company.active;
        this.tempCompany.web = company.web;
        this.tempCompany.twitter = company.twitter;
        this.tempCompany.facebook = company.facebook;


        this.displayCompany = true;
    }

    convertHMS(value) {
        const sec = parseInt(value, 10); // convert value to number if it's string
        let hours = Math.floor(sec / 3600); // get hours
        let minutes = Math.floor((sec - hours * 3600) / 60); // get minutes
        return (
            this.padLeadingZeros(hours, 2) +
            ":" +
            this.padLeadingZeros(minutes, 2)
        ); // Return is HH : MM : SS
    }

    padLeadingZeros(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    getConfigurtationFortimeout() {
        this.service
            .getCaseConfigurationsByNameTimeout("LionO360 CRM Default Timeout")
            .then((resp) => {
                this.DefaultTimeoutData = resp;
                this.allSettings = [
                    {
                        id: 1,
                        name: "Idle time out",
                        value: this.convertHMS(
                            JSON.parse(
                                resp.configurationDetails[0].configJSONValue
                            ).DefaultTimeOut
                        ),
                    },
                ];
            });
    }

    updateOrganization() {
        this.appMainService.isShowSpinner("updateCompany");
        const img: ImageDetails = {
            content: this.tempCompany.image ? this.tempCompany.image : "",
            description: "string",
            extension: "jpg",
            guidName: "logo",
            name: "logo"
          };

          let temp: EditCompanyDetails = {
            name: this.tempCompany.name,
            founderName: this.tempCompany.founder,
            establishDate: this.tempCompany.estDate,
            website: this.tempCompany.web,
            facebookIdentification: this.tempCompany.facebook,
            twitterIdentification: this.tempCompany.twitter,
            image: img,
            timeZoneId: this.selectedTimeZone?.id
          };

        this.service.updateOrg(temp).subscribe((org) => {
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Updated Successfully...",
            });
            this.getCompanyAndBranches();
            this.getTimeZoneList();
            this.appMainService.isHideSpinner("updateCompany");
            this.displayCompany = false;
        });
    }

    getOrgSettings() {
        this.service.getDecimalValue().subscribe((res) => {
            this.allSettings = res?.map(item => {
                return {
                    // Example transformation: change property names and values
                    name: item.name,
                    code: item.code,
                    value: (item.code == 'decimal' || item.code == 'qtydecimal') ? item.value : this.convertHMS(item.value)
                };
            });
        })
    }

    saveAddEditBranch() {
        this.appMainService.isShowSpinner("addEditBranch");
        if (this.addressInput === "") {
            this.showAddressValidationError = true;
        } else {
            this.showAddressValidationError = false;

            let headOfficeTypeId = this.allTypes.filter(
                (e) => e.name == "Head Office"
            )[0].id;
            let branchOfficeTypeId = this.allTypes.filter(
                (e) => e.name == "Sub Branch"
            )[0].id;
            let organizationAddressPhone = [];
            if (this.tempBranch.phone) {
                organizationAddressPhone = [
                    {
                        organizationId: this.app.companyId,
                        organizationAddressId:
                            this.branchHeader == "Add Branch"
                                ? 0
                                : this.tempBranch.id,
                        phoneId: this.tempBranch.editPhoneId,
                        phone: {
                            // number: this.stripPhoneNumberMask(this.tempBranch.phone, this.selectedCountry?.PhoneCode),
                            number: this.tempBranch.phone,
                            extension: "911",
                            description: "string",
                            phoneTypeId: 10,
                            phoneType: null,
                            statusId: 1,
                            status: null,
                            id: this.tempBranch.editPhoneId,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.user.userId,
                            createdDate: new Date(),
                            updatedDate: new Date(),
                        },
                        statusId: 1,
                        status: null,
                        id: this.tempBranch.phoneMainId,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: new Date(),
                        updatedDate: new Date(),
                    },
                ];
            }

            let organizationAddressEmail = [];
            if (this.tempBranch.emailId) {
                organizationAddressEmail = [
                    {
                        organizationId: this.app.companyId,
                        organizationAddressId:
                            this.branchHeader == "Add Branch"
                                ? 0
                                : this.tempBranch.id,
                        emailId: this.tempBranch.editEmailId,
                        email: {
                            emailAddress: this.tempBranch.emailId,
                            description: "string",
                            emailTypeId: 30,
                            emailType: null,
                            statusId: 1,
                            status: null,
                            id: this.tempBranch.editEmailId,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: this.app.user.userId,
                            createdDate: new Date(),
                            updatedDate: new Date(),
                        },
                        statusId: 1,
                        status: null,
                        id: this.tempBranch.emailMainId,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.user.userId,
                        updatedBy: this.app.user.userId,
                        createdDate: new Date(),
                        updatedDate: new Date(),
                    },
                ];
            }

            let temp = {
                id: this.branchHeader == "Add Branch" ? 0 : this.tempBranch.id,
                locationId: this.tempBranch?.locationId,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: new Date(),
                updatedDate: new Date(),
                organizationId: this.app.companyId,
                locationTypeId:
                    this.tempBranch.locationTypeObj == undefined
                        ? 0
                        : this.tempBranch.locationTypeObj.id,
                locationType: null,
                addressId:
                    this.branchHeader == "Add Branch"
                        ? 0
                        : this.tempBranch.addressId,
                address: {
                    name: this.tempBranch.name,
                    streetAddress1: this.formattedaddress,
                    streetAddress2: this.tempBranch?.streetAddress2,
                    description: "Office Address 1",
                    latitude: this.latitude,
                    longitude: this.longitude,
                    cityId: this.selectedAddressCity?.id,
                    city: null,
                    stateId: this.selectedAddressState?.id,
                    state: null,
                    countryId: this.selectedAddressCountry?.id,
                    country: null,
                    zipCode: this.tempBranch.zip,
                    attnContactId: null,
                    attnContact: null,
                    statusId: 1,
                    status: null,
                    id:
                        this.branchHeader == "Add Branch"
                            ? 0
                            : this.tempBranch.addressId,
                    addressTypeId: 38,
                    addressType: null,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: new Date(),
                    updatedDate: new Date(),
                },
                statusId: 1,
                status: null,
                typeId: this.tempBranch.headOffice
                    ? headOfficeTypeId
                    : branchOfficeTypeId,
                type: null,
                organizationAddressPhone: organizationAddressPhone,
                organizationAddressEmail: organizationAddressEmail,
            };

            if (this.branchHeader == "Add Branch") {
                this.service.addBranch(temp).subscribe((org) => {
                    this.getCompanyAndBranches();
                    this.displayBranch = false;
                    this.appMainService.isHideSpinner("addEditBranch");
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Branch Added Successfully...",
                    });
                });

            } else {
                this.service.updateBranch(temp).subscribe((org) => {
                    this.getCompanyAndBranches();
                    this.displayBranch = false;
                    this.appMainService.isHideSpinner("addEditBranch");
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Branch Edited Successfully...",
                    });
                });
            }

        }
    }

    displayBranch = false;
    branchHeader = "Add Branch";
    tempBranch: any = {
        id: "",
        locationId: "",
        name: "",
        phone: "",
        phoneMainId: 0,
        editPhoneId: 0,
        emailId: "",
        emailMainId: 0,
        editEmailId: 0,
        addressId: 1,
        address: "",
        city: "",
        cityObj: null,
        state: "",
        stateObj: null,
        country: "",
        countryObj: null,
        zip: "",
        locationType: "",
        locationTypeObj: null,
        headOffice: true,
        latitude: 0,
        longitude: 0,
    };

    addBranch(branch) {
        // const defaultCountry = this.app.userDetails?.locations[0]?.address?.country?.name;
        // this.selectedCountry = this.countryData.find(ct => ct.CountryName === defaultCountry);
        this.loadcompanyData()
        this.showAddressValidationError = false;
        this.tempCompany = JSON.parse(JSON.stringify(branch));
        this.branchHeader = "Add Branch";
        this.addressInput = "";
        this.formattedaddress = "";
        this.showAccountInfoMore = false;
        this.tempBranch = {
            id: "",
            locationId: "",
            name: "",
            phone: "",
            phoneMainId: 0,
            editPhoneId: 0,
            emailId: "",
            emailMainId: 0,
            editEmailId: 0,
            addressId: 1,
            address: "",
            city: "",
            cityObj: "",
            state: "",
            stateObj: "",
            country: "",
            countryObj: "",
            zip: "",
            locationType: "",
            locationTypeObj: "",
            streetAddress2: "",
            headOffice: false,
            latitude: 0,
            longitude: 0,
        };
        this.selectedAddressCountry = {};
        this.selectedAddressState = {};
        this.selectedAddressCity = {};
        this.displayBranch = true;
    }

    async editBranch(branch) {
        await this.loadcompanyData();
        this.addressInput = '';
        this.formattedaddress = null;
        this.showAddressValidationError = false;
        this.selectedAddressCountry = this.countries.find(
            (c) => c.id == branch.countryId
        );
        if (branch?.countryId) {
            this.allStates = await this.service.getAllStates(branch.countryId).catch(err => {
                return [];
            });
        }
        if (branch?.stateId) {
            this.allCities = await this.service.getAllCities(branch.stateId).catch(err => {
                return [];
            });
        }
        this.selectedAddressState = this.allStates?.find(
            (s) => s.id == branch?.stateId
        );
            let stateObj = this.allStates?.find((e) => e.id == branch?.stateId);
                this.selectedAddressCity = this.allCities?.find(
                    (c) => c.id == branch?.cityId
                );
                let cityObj = this.allCities?.find(
                    (e) => e.id == branch?.cityId
                );
                this.tempBranch = {
                    id: branch.id,
                    locationId: branch?.locationId,
                    name: branch.name,
                    phone: branch.phone,
                    streetAddress2: branch.streetAddress2,
                    phoneMainId: branch?.phoneMainId || 0,
                    editPhoneId: branch?.editPhoneId || 0,
                    emailId: branch.emailId,
                    emailMainId: branch?.emailMainId || 0,
                    editEmailId: branch?.editEmailId || 0,
                    addressId: branch.addressId,
                    address: branch.address,
                    country: "",
                    countryObj: this.countries.find(
                        (e) => e.id == branch.countryId
                    ),
                    state: "",
                    stateObj: stateObj,
                    city: "",
                    cityObj: cityObj,
                    zip: branch.zip,
                    locationType: "",
                    locationTypeObj: this.locationTypes.find(
                        (e) => e.id == branch.locationTypeId
                    ),
                    headOffice: branch.headOffice,
                    latitude: branch.latitude,
                    longitude: branch.longitude,
                };
                this.branchHeader = "Edit Branch";
                this.displayBranch = true;
                this.addressInput = branch.address;
                this.formattedaddress = branch.address;
    }

    deleteBranch(branch) {
        this.confirmationService.confirm({
            message: "Are you sure that you want to delete this branch?",
            header: "Confirmation!",
            accept: () => {

                this.service.deleteBranch(branch.id).subscribe({
                    next: (response) => {
                        this.getCompanyAndBranches();
                        this.displayBranch = false;
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Branch Deleted Successfully...",
                        });
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Failed to delete this Branch!",
                        });
                    },
                    complete: () => {

                    }
                });
            },
        });
    }

    hideAddEditBranchModal() {
        this.displayBranch = false;
    }

    onRemoveAddressLocation(event) {
        this.addressInput = "";
        this.formattedaddress = "";
        this.selectedAddressCountry = null;
        this.selectedAddressState = null;
        this.selectedAddressCity = null;
        this.tempBranch.zip = "";
    }

    onAddressBlur(address) {
        this.addressInput = address;
        this.formattedaddress = this.addressInput;
        if (address == "") {
            this.addressInput = '';
            this.formattedaddress = '',
                this.selectedAddressCountry = null;
            this.selectedAddressState = null;
            this.selectedAddressCity = null;
            this.tempBranch.zip = "";
        }
    }

    async onAddressChanged(address: any) {
        this.onRemoveAddressLocation(address);
        this.formattedaddress = address.formatted_address;
        const googleAddressObj = this.getAddressObj(address);
        setTimeout(() => {
            const da = this.getStreetAddres(googleAddressObj); //updatedAddressLine;
            this.addressInput = da;
            this.formattedaddress = da;
        });
        this.latitude = googleAddressObj.latitude;
        this.longitude = googleAddressObj.longitude;
        let searchedCountry = googleAddressObj.country
            ? googleAddressObj.country.long_name
            : "";
        let searchedZipcode = googleAddressObj.zipCode
            ? googleAddressObj.zipCode.long_name
            : "";
        let searchedState = googleAddressObj.state
            ? googleAddressObj.state.long_name
            : "";
        let searchedCity = googleAddressObj.city
            ? googleAddressObj.city.long_name
            : "";
        if (searchedCountry) {
            let matchedCountry;
            if (
                searchedCountry == "USA" ||
                searchedCountry == "United States"
            ) {
                matchedCountry = this.countries.find(
                    (obj) =>
                        obj.name == searchedCountry ||
                        obj.countryCode == googleAddressObj.country.short_name
                );
            } else {
                matchedCountry = this.countries.find(
                    (obj) => obj.name == searchedCountry
                );
            }

            this.selectedAddressCountry = matchedCountry;
            //set zipcode
            if (searchedZipcode) {
                this.tempBranch.zip = searchedZipcode;
            }

            if (matchedCountry) {
                this.appMainService.isShowSpinner("loadStates");
                this.allStates = await this.getStates(matchedCountry);
                this.appMainService.isHideSpinner("loadStates");

                if (searchedState) {
                    //set state
                    let matchedState = this.allStates.find(
                        (obj) =>
                            obj.name == searchedState ||
                            obj.shortName == googleAddressObj.state.short_name
                    );
                    if (!matchedState) {
                        // add state
                        matchedState = await this.addState(
                            googleAddressObj.state,
                            matchedCountry.id
                        );
                    }
                    this.appMainService.isShowSpinner("loadCity");
                    this.allCities = await this.getCities(matchedState);
                    this.appMainService.isHideSpinner("loadCity");
                    this.selectedAddressState = matchedState;

                    if (searchedCity) {
                        //set city
                        let matchedCity = this.allCities
                            ? this.allCities.find(
                                (obj) => obj.name == searchedCity
                            )
                            : null;
                        if (!matchedCity) {
                            matchedCity = await this.addCity(
                                searchedCity,
                                matchedState.id
                            );
                        }
                        this.selectedAddressCity = matchedCity;
                    }
                }
            }
        }
    }

    getAddressObj(address) {
        const addressObj = {
            street_number: null,
            subpremise: null,
            plus_code: null,
            neighborhood: null,
            landmark: null,
            route: null,
            sublocality_level_3: null,
            sublocality_level_2: null,
            sublocality_level_1: null,
            locality: null,
            city: null,
            state: null,
            country: null,
            zipCode: null,
            latitude: address.geometry.location.lat(),
            longitude: address.geometry.location.lng(),
        };
        address.address_components.forEach((comp) => {
            const field = comp.types[0];
            if (field == "street_number") {
                addressObj.street_number = comp;
            }
            if (field == "plus_code") {
                addressObj.plus_code = comp;
            }
            if (field == "neighborhood") {
                addressObj.neighborhood = comp;
            }
            if (field == "landmark") {
                addressObj.landmark = comp;
            }
            if (field == "route") {
                addressObj.route = comp;
            }
            if (field == "sublocality_level_3") {
                addressObj.sublocality_level_3 = comp;
            }
            if (field == "sublocality_level_2") {
                addressObj.sublocality_level_2 = comp;
            }
            if (field == "sublocality_level_1") {
                addressObj.sublocality_level_1 = comp;
            }
            if (field == "subpremise") {
                addressObj.subpremise = comp;
            }
            // city
            if (field == "locality") {
                addressObj.locality = comp;
                addressObj.city = comp;
            }
            if (field == "administrative_area_level_1") {
                addressObj.state = comp;
            }

            if (field == "country") {
                addressObj.country = comp;
            }
            if (field == "postal_code") {
                addressObj.zipCode = comp;
            }
        });
        if (addressObj.city == null) {
            addressObj.city = addressObj.sublocality_level_1;
        }
        return addressObj;
    }

    getStreetAddres(googleAddressObj) {
        const street = [];
        if (googleAddressObj.plus_code) {
            street.push(googleAddressObj.plus_code.long_name);
        }
        if (googleAddressObj.street_number) {
            street.push(googleAddressObj.street_number.long_name);
        }
        if (googleAddressObj.route) {
            street.push(googleAddressObj.route.long_name);
        }
        if (googleAddressObj.subpremise) {
            street.push(`#${googleAddressObj.subpremise.long_name}`);
        }
        if (googleAddressObj.neighborhood) {
            street.push(googleAddressObj.neighborhood.long_name);
        }
        if (googleAddressObj.sublocality_level_3) {
            street.push(googleAddressObj.sublocality_level_3.long_name);
        }
        if (googleAddressObj.sublocality_level_2) {
            street.push(googleAddressObj.sublocality_level_2.long_name);
        }
        if (
            googleAddressObj.sublocality_level_1 &&
            googleAddressObj.locality != null
        ) {
            street.push(googleAddressObj.sublocality_level_1.long_name);
        }
        return street.length ? street.join(" ") : "";
    }

    getStates(country) {
        if (country && country.id) {
            return this.addEditAddressModalService.getAllStates(country.id);
        } else {
            return [];
        }
    }

    getCities(state) {
        if (state && state.id) {
            return this.addEditAddressModalService.getAllCities(state.id);
        } else {
            return [];
        }
    }

    async addCity(searchedCityName, stateId) {
        const data = {
            id: 0,
            createdSource: this.app.user.userIP,
            updatedSource: null,
            createdBy: this.app.user.userId,
            updatedBy: 0,
            createdDate: new Date(),
            updatedDate: null,
            name: searchedCityName,
            description: searchedCityName,
            stateId: stateId,
            statusId: 1,
        };
        this.appMainService.isShowSpinner("addNewCity");
        const newAddedCity = await this.addEditAddressModalService.addCity(
            data
        );
        this.cityList = addInList(this.cityList, newAddedCity);
        this.appMainService.isHideSpinner("addNewCity");
        return newAddedCity;
    }

    async addState(stateDetails, countryId) {
        const data = {
            id: 0,
            createdSource: this.app.user.userIP,
            updatedSource: null,
            createdBy: this.app.user.userId,
            updatedBy: 0,
            createdDate: new Date(),
            updatedDate: null,
            name: stateDetails.long_name,
            shortName: stateDetails.short_name,
            description: stateDetails.long_name,
            countryId: countryId,
            statusId: 1,
        };
        this.appMainService.isShowSpinner("addNewState");
        const newAddedState = await this.addEditAddressModalService.addState(
            data
        );
        this.allStates = addInList(this.stateList, newAddedState);
        this.appMainService.isHideSpinner("addNewState");
        return newAddedState;
    }

    async loadCountryStates() {
        this.stateList = await this.getStates(this.selectedAddressCountry);
        this.allStates = this.stateList;
    }

    async loadCountryCities() {
        this.cityList = await this.getCities(this.selectedAddressState);
        this.allCities = this.cityList ;
    }

    selectFile(event) {
        this.fileData = <File>event.target.files[0];
        this.preview();
    }

    public preview() {
        // Show preview
        var mimeType = this.fileData.type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }

        var reader = new FileReader();
        reader.readAsDataURL(this.fileData);
        reader.onload = (_event) => {
            this.tempCompany.image = reader.result + "";
        };
    }

    editSetting(value) {
       this.companyInitForm(value);
       this.companyForm.patchValue(value);
       this.displaySetting2 = true;
    }

    getTimeZoneList() {
        this.accountService.getTimezone().then(timezoneList => {
            this.timeZoneList = timezoneList;
            this.selectedTimeZone = this.timeZoneList.find(tZone => tZone.id === this.organizationFullDetails.timeZoneId)
        });
    }

    getAllMFAUserList() {
        this.appMainService.isShowSpinner("userList");
        this.service.getMFAUserList().subscribe(
            {
                next: (response) => {
                    this.allTwoFactorData = response;
                    this.filterTableRowsMFA();
                    this.appMainService.isHideSpinner("userList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("userList");
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'failed, please try again...'
                    });

                },
                complete: () => { },
            });
    }

    filterTableRowsMFA() {
        this.selectedFactor = [];
        if (this.isEnable) {
            this.twoFactor = this.allTwoFactorData.filter(user => user.mfaEnableStatus);
        } else {
            this.twoFactor = this.allTwoFactorData.filter(user => !user.mfaEnableStatus);
        }
        this.clearSearchInput();
    }

    enableDisableFactor(isEnable: boolean) {
        if (this.selectedFactor.length > 0) {
            const confirmationMessage = isEnable ? 'Enable all selected users?' : 'Disable all selected users?';
            this.confirmationService.confirm({
                message: confirmationMessage,
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    const userData = this.selectedFactor.map(item => item.id);
                    let data: any = {
                        id: userData,
                        mfaEnableStatus: isEnable
                    };
                    this.service.setUserMFA(data).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
                        {
                            next: (response) => {
                                this.allTwoFactorData = response;
                                this.selectedFactor = [];
                                this.clearSearchInput();
                                this.filterTableRowsMFA();
                            },
                            error: (error) => {
                            },
                            complete: () => { },
                        });
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: isEnable ? 'Enabled Successfully' : 'Disabled Successfully' });
                },
                reject: () => { }
            });
        }
    }

    clearSearchInput(): void {
        // Clear the value of the input field
        if (this.searchInput && this.searchInput.nativeElement) {
            this.searchInput.nativeElement.value = '';
            // Reset the table filter
            this.dt2.reset();
        }

    }

    openConfirmationDialog(product: any): void {
        this.confirmationService.confirm({
            message: 'Are you sure you want to re-set authentication?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.service.userReSetAuthen(product?.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
                    {
                        next: (response) => {
                            this.allTwoFactorData = response;
                            this.filterTableRowsMFA();
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Authentication Re-set Successfully ' });
                        },
                        error: (error) => {
                            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Authentication Re-set failed ' });
                        },
                        complete: () => { },
                    });

            },
            reject: () => {

            }
        });
    }

    refreshData() {
        this.getAllMFAUserList();
    }

    toggleAllRows(event: any) {
        this.selectAll = event.checked;
        this.selectedBranches = this.selectAll
            ? this.company?.branches.filter(branch => !branch.headOffice)
            : [];
        this.company?.branches.forEach(branch => {
            if (!branch.headOffice) {
                branch.selected = this.selectAll;
            }
        });
    }

    deleteAddress() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to Delete Address?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const selectedBranchesIds: any = this.selectedBranches
                    .filter(data => !data.headOffice) // Exclude objects with property 'Head Office' true
                    .map(data => data.id);
                const data: any = {
                    "ids": selectedBranchesIds
                }
                this.companyService.deleteMultipleAddress(data).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
                    {
                        next: (response) => {
                            this.getCompanyAndBranches();
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address Deleted Successfully' });
                        },
                        error: (error) => {
                            this.messageService.add({ severity: 'error', summary: 'Error', detail: ' Failed to Delete Address' });
                        },
                        complete: () => { },
                    });

            },
            reject: () => {
                this.selectedBranches = [];
            }
        });


    }

    getCountryData(data?) {
        this.accountUserService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response) => {
                        this.countryData = response;
                        this.selectedCountry = this.countryData.find(item => item.CountryName === this.app.userDetails?.locations?.[0]?.address?.country?.name);
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'please try again...'
                        });

                    },
                    complete: () => { },
                });
    }

    onCountrySelect(event: any, phone: any) {
        // const selectedCountry = this.countryData.find(item => item.CountryName === event.value);
        // if(selectedCountry){
        //     phone.phone.code = selectedCountry.PhoneCode;
        //     phone.phone.number= ""
        // }
        this.tempBranch.phone = "";

    }

    async getPhoneNumberTemplate() {
        this.phoneNumberFormat = await this.phoneNumberFormatService.getPhoneNumberFormat();
    }

    stripPhoneNumberMask(phoneNumber: string, countryCode: string | null): string {
        const unMaskedNumber = this.phoneNumberFormatService.removeMaskingFromNumber(phoneNumber);
        return countryCode ? `${countryCode}-${unMaskedNumber}` : unMaskedNumber;
    }

    saveDecimalValue(data){
        this.appMainService.isShowSpinner("saveDecimalValue");
        if(data?.code === 'timeout'){
            let timevalue =
            parseInt(moment(data?.value).format("HH")) * 60 * 60 +
            parseInt(moment(data?.value).format("mm")) * 60;
            this.organizationFullDetails.timeOut = timevalue;
        }else if(data?.code === 'decimal'){
            this.organizationFullDetails.decimalLimit = data?.value;
        }else{
            this.organizationFullDetails.qtyDecimalLimit = data?.value;
        }
        const isSetting = true ;
        if (this.organizationFullDetails && this.organizationFullDetails.image && !this.organizationFullDetails.image.statusId) {
            this.organizationFullDetails.image.statusId = 1;
        }
        this.service.updateOrganization(this.organizationFullDetails,isSetting).subscribe({
            next: (org)=>{
                this.displaySetting2 = false;
                this.importService.setDecimalValue(org?.decimalLimit);
                this.importService.setQtyDecimalValue(org?.qtyDecimalLimit);
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Updated Successfully...",
                });
                this.getOrgSettings();
                this.appMainService.isHideSpinner("saveDecimalValue");
            },
            error: (error) => {
                this.displaySetting2 = false;
                this.appMainService.isHideSpinner("saveDecimalValue");
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error occurred while saving data...'
                });
            }
        });
    }

    companyInitForm(value?) {
        this.companyForm = this.fb.group({
            name: ['',[Validators.required]],
            value: [''],
            code: ['']
        });
        this.companyForm.controls['value'].clearValidators();
        if (value) {
            const control = this.companyForm.controls['value'];
            if (value.code === 'decimal' || value.code === 'qtydecimal') {
              control.setValidators([
                Validators.required,
                Validators.min(0),
                Validators.max(6),
              ]);
            } else {
              control.setValidators([Validators.required]);
            }
            // Update the validity and status of the control
            control.updateValueAndValidity();
          }
          
    }

    ngOnDestroy(): void {
        window["cpntRef"] = null;
    }

}
